import { useCallback, useEffect, useState } from 'react';

import BaseService from '../../../../services/BaseService';

import { compareAuditByTimestampDesc } from '../utils/formatAuditHistorico';

const historicoCache = new Map();

const normalizeHistoricoResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const useNsirHistorico = (nsirId, { enabled = true } = {}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const fetchHistorico = useCallback(async ({ force = false } = {}) => {
    if (!nsirId || !enabled) return;

    if (!force && historicoCache.has(nsirId)) {
      setItems(historicoCache.get(nsirId));
      setLoadError(false);
      return;
    }

    setLoading(true);
    setLoadError(false);

    try {
      const response = await BaseService.get({ url: `nsirs/${nsirId}/historico` });
      const list = normalizeHistoricoResponse(response.data)
        .slice()
        .sort(compareAuditByTimestampDesc);

      historicoCache.set(nsirId, list);
      setItems(list);
    } catch {
      setItems([]);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [nsirId, enabled]);

  useEffect(() => {
    if (!enabled) {
      setItems([]);
      setLoadError(false);
      return;
    }
    fetchHistorico();
  }, [enabled, fetchHistorico]);

  const refetch = useCallback(
    () => fetchHistorico({ force: true }),
    [fetchHistorico],
  );

  return {
    items,
    loading,
    loadError,
    refetch,
  };
};

export default useNsirHistorico;
